import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@detco/my-ibe-icons/dist';
export const MyIbeCalenderRestrictions = (props) => {
    const { restrictions } = props;
    return (_jsx("div", { className: "ibe-calender-restrictions", children: restrictions
            .filter((restriction) => restriction.show)
            .map((restriction) => {
            const restrictionKey = `restriction-${restriction.name}`;
            const className = `ibe-restriction-warning ${restriction.className}`;
            return (_jsxs("div", { className: className, children: [_jsx(Icon, { className: "ibe-restriction-warning-icon", icon: restriction.icon || 'warning-circle', size: 16 }), _jsx("span", { className: "ibe-restriction-warning-text", children: restriction.name })] }, restrictionKey));
        }) }));
};
//# sourceMappingURL=MyIbeCalenderRestrictions.js.map